"use client"

import { useMutation, useQueryClient } from "@tanstack/react-query"
import {
  createApiKeyAction,
  deleteApiKeyAction,
  type CreatedApiKey,
} from "@/server-actions/api-keys"
import { apiKeysQueryKey } from "@/hooks/queries/api-keys"
import { useTranslatedQueryHandling } from "@/hooks/use-translated-query-handling"

import { useTranslations } from "next-intl"


export function useCreateApiKeyMutation() {
  const withQueryHandling = useTranslatedQueryHandling()

  const tUi = useTranslations("Feedback.MutationsApiKeys")

  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ name }: { name: string }): Promise<CreatedApiKey> => {
      const result = await withQueryHandling(createApiKeyAction({ name }), {
        loading: tUi("creatingAPIKey"),
        success: tUi("aPIKeyCreated"),
      })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: apiKeysQueryKey })
    },
  })
}

export function useDeleteApiKeyMutation() {
  const withQueryHandling = useTranslatedQueryHandling()

  const tUi = useTranslations("Feedback.MutationsApiKeys")

  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      const result = await withQueryHandling(deleteApiKeyAction({ id }), {
        loading: tUi("revokingAPIKey"),
        success: tUi("aPIKeyRevoked"),
      })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: apiKeysQueryKey })
    },
  })
}
